import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { Mode } from '../types';

interface GeoData {
  country: string;
  city: string;
}

// Cache geo data so we only fetch once per session
let geoCache: GeoData | null = null;

async function getGeo(): Promise<GeoData> {
  if (geoCache) return geoCache;
  try {
    const res = await fetch('https://ipapi.co/json/');
    if (res.ok) {
      const data = await res.json();
      geoCache = { country: data.country_name || 'unknown', city: data.city || 'unknown' };
      return geoCache;
    }
  } catch {
    // silently fail
  }
  return { country: 'unknown', city: 'unknown' };
}

export function useVisitTracker(mode: Mode) {
  useEffect(() => {
    const track = async () => {
      try {
        const { country, city } = await getGeo();
        await supabase.from('cv_visits').insert({
          referrer: document.referrer || null,
          language: navigator.language,
          country,
          city,
          user_agent: navigator.userAgent,
          screen_width: window.screen.width,
          screen_height: window.screen.height,
          mode,
        });
      } catch {
        // never break the app for analytics
      }
    };

    track();
  }, [mode]); // re-runs when user switches mode
}
